import { ReactElement, useMemo } from 'react';
import { Icon } from '@cbhq/cds-web/icons/Icon';

import { useClientProps } from '../providers/ClientPropsProvider';
import { CustomMenuAction } from '../types';

import { TogglerActionItem } from './TogglerActionItem';

export function useCustomMenuActions() {
  const { customMenuActions } = useClientProps();

  const items = useMemo(() => {
    return (
      customMenuActions?.map(({ icon, label, type, onToggle, toggleValue }: CustomMenuAction) => {
        const navIcon = <Icon name={icon} color="fg" />;

        if (type === 'toggle') {
          return (
            <TogglerActionItem
              key={label}
              icon={navIcon}
              label={label}
              toggleValue={toggleValue}
              callback={onToggle}
            />
          );
        }
        return undefined;
      }) ?? []
    );
  }, [customMenuActions]);

  return items.filter(Boolean) as ReactElement[];
}
